import React from 'react';

const StudentDashboard = ({ onLeave }) => {
  return (
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      <div>You belong to a classroom.</div>
      <button
        style={{
          marginTop: '20px',
          padding: '10px 24px',
          borderRadius: '8px',
          background: '#ff4d4f',
          color: '#fff',
          border: 'none',
          fontWeight: 'bold',
          cursor: 'pointer'
        }}
        onClick={onLeave}
      >
        Leave Classroom
      </button>
    </div>
  );
};

export default StudentDashboard;